<template>
  <h1>
    {{ title }}
    <span class="e">MARINE LIFE</span>
  </h1>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/atoms/privateCruising/contentTitle.scss";
</style>
